import type { CampaignQuestGroup } from "../../types";

/** Returns groups with the qualifying quest (if eligible) moved into a leading "Start here" group. */
export function elevateStartHere(
  groups: CampaignQuestGroup[],
  qualifyingId?: string,
  referralAccepted?: boolean,
): CampaignQuestGroup[] {
  if (!qualifyingId || !referralAccepted) {
    // Return shallow copy
    return groups.map((g) => ({ name: g.name, quests: [...g.quests] }));
  }

  let groupIndex = -1;
  let questIndex = -1;

  for (let gi = 0; gi < groups.length; gi++) {
    const qualifyingQuestIndex = groups[gi].quests.findIndex((q) => {
      const hasBonus = Number(q.referralBonusPoints ?? 0) > 0;
      return q.externalId === qualifyingId && hasBonus;
    });
    if (qualifyingQuestIndex !== -1) {
      groupIndex = gi;
      questIndex = qualifyingQuestIndex;
      break;
    }
  }

  if (groupIndex === -1 || questIndex === -1) {
    return groups.map((g) => ({ name: g.name, quests: [...g.quests] }));
  }

  const qualifyingQuest = groups[groupIndex].quests[questIndex];

  // Remove the qualifying quest from its original group
  const newGroups: CampaignQuestGroup[] = groups
    .map((group, gi) => {
      if (gi === groupIndex) {
        return {
          ...group,
          quests: group.quests.filter((_, qi) => qi !== questIndex),
        };
      }
      return group;
    })
    .filter((g) => g.quests.length > 0);

  return [{ name: "Start here", quests: [qualifyingQuest] }, ...newGroups];
}
